import { useAuthStore } from '@/store/auth'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    const { organizationId } = useAuthStore.getState()

    if (organizationId) {
      throw redirect({
        to: '/org/$orgId/dashboard',
        params: { orgId: organizationId },
      })
    } else {
      throw redirect({ to: '/login' })
    }
  },
})
